import { render, staticRenderFns, recyclableRender, components } from "./couponOprae.vue?vue&type=template&id=0ebcba4c&scoped=true&"
var renderjs
import script from "./couponOprae.vue?vue&type=script&lang=js&"
export * from "./couponOprae.vue?vue&type=script&lang=js&"
import style0 from "./couponOprae.vue?vue&type=style&index=0&id=0ebcba4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebcba4c",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/coupon/couponOprae.vue"
export default component.exports